import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { generatePath, useHistory } from 'react-router-dom'
import { orderActions } from '../../store/order'
import { ORDER_API } from '../../api/order'
import ROUTES from '../../routes'
import { useStore } from 'effector-react'
import { optionsActions, optionsStore } from '../../store/options'
import ReCAPTCHA from 'react-google-recaptcha'
import Form from '../components/Forms/Form'
import Alert from '../components/Alerts/Alert'
import Row from '../components/Layout/Row'
import Col from 'reactstrap/lib/Col'
import FormGroup from 'reactstrap/lib/FormGroup'
import Label from 'reactstrap/lib/Label'
import Button from '../components/Buttons/Button'
import Input from 'reactstrap/lib/Input'
import FormFeedback from 'reactstrap/lib/FormFeedback'
import { useError, useTranslator } from '../../hooks'
import Spinner from '../components/Spinners/Spinner'
import HelpButton from './HelpButton'

const OrderRequest = () => {
  const options = useStore(optionsStore)
  const translator = useTranslator()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [hasError, setHasError] = useError()
  const [captchaToken, setCaptchaToken] = useState(null)
  const { register, handleSubmit, errors, formState } = useForm({ mode: 'onChange' })
  const { isValid } = formState

  const onSubmit = (data) => {
    setLoading(true)
    ORDER_API.fetch(data.orderNumber, data.transactionNumber, captchaToken)
      .then((order) => {
        setLoading(false)
        optionsActions.setOption({ isRemainingAccessCount: true })
        orderActions.update(order)
        history.push(
          generatePath(ROUTES.order, {
            orderNumber: order.orderNumber,
            transactionNumber: order.transactionNumber,
          })
        )
      })
      .catch((e) => {
        setLoading(false)
        if (e.message === '401') {
          optionsActions.setOption({ isRemainingAccessCount: false })
        } else {
          setHasError(true)
        }
      })
  }

  const onCaptchaVerified = (value) => setCaptchaToken(value)

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Alert dismiss={false} fade={false} color="danger">
        <p
          className="message"
          dangerouslySetInnerHTML={{
            __html: translator('orderRequest.news.message'),
          }}
        />
        <p
          className="help"
          dangerouslySetInnerHTML={{
            __html: translator('orderRequest.news.help'),
          }}
        />
      </Alert>
      {!hasError ? (
        <legend
          dangerouslySetInnerHTML={{
            __html: translator('orderRequest.instruction'),
          }}
        />
      ) : (
        <Alert dismiss={false} fade={false} color="danger">
          <p
            className="message"
            dangerouslySetInnerHTML={{
              __html: translator('orderRequest.notFound.message'),
            }}
          />
          <p className="help">
            <small>{translator('orderRequest.notFound.help')}</small>
          </p>
        </Alert>
      )}
      <Row justifyContent="center">
        <Col xs="12" md="10" lg="8">
          <FormGroup>
            <Label for="transactionNumber">{translator('orderRequest.form.transaction.field')}</Label>
            <HelpButton />
            <Input
              type="text"
              invalid={!!errors.transactionNumber}
              innerRef={register({ required: true })}
              name="transactionNumber"
              id="transactionNumber"
              disabled={loading}
            />
            <FormFeedback>{translator('validation.required')}</FormFeedback>
          </FormGroup>
          <FormGroup>
            <Label for="orderNumber">{translator('orderRequest.form.order.field')}</Label>
            <HelpButton />
            <Input
              type="text"
              invalid={!!errors.orderNumber}
              innerRef={register({ required: true })}
              name="orderNumber"
              id="orderNumber"
              disabled={loading}
            />
            <FormFeedback>{translator('validation.required')}</FormFeedback>
          </FormGroup>
          <FormGroup className="text-center">
            {!options.isRemainingAccessCount && (
              <ReCAPTCHA
                style={{ display: 'inline-block' }}
                sitekey={options.googleApiKey}
                onChange={onCaptchaVerified}
              />
            )}
          </FormGroup>
          {!loading && (
            <Button
              color="primary"
              type="submit"
              disabled={(!captchaToken && !options.isRemainingAccessCount) || !isValid}
            >
              Valider
            </Button>
          )}
          {loading && <Spinner color="danger" style={{ width: '4rem', height: '4rem' }} />}
        </Col>
      </Row>
    </Form>
  )
}

export default OrderRequest
